import React from "react";
import { InvoiceDateWise, InvoiceUserData } from "../../../../redux/listing/listingTypes";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { USER_WISE_INNER_HEADERS } from "../../../../constant/tableHeadersConstants/UserAndClientWiseOCRReportConst";
import { reverseDate } from "../../../../utils/commonFunctions";

type AppProps = {
  data: InvoiceUserData[] | [];
  tableHeader: TableHeadersType[] | [];
  setData: React.Dispatch<React.SetStateAction<[] | InvoiceUserData[]>>;
};
const SignleUserWiseTableData = ({ data, tableHeader, setData }: AppProps) => {
  return (
    <>
      {data?.length > 0 &&
        data.map(
          (itemData: any, outerIndex: number) =>
            itemData?.date_wise?.length > 0 &&
            itemData.date_wise.map((insideData: InvoiceDateWise, innerIndex: number) => {
              return (
                <tr key={`row-${outerIndex}-${innerIndex}`}>
                  {USER_WISE_INNER_HEADERS?.map(
                    (header: TableHeadersType, i: number) => {
                      if (header?.value === "date") {
                        return (
                          <td key={i}>
                            {reverseDate(insideData?.invoice_date)}
                          </td>
                        );
                      } else if (header?.value === "expenses") {
                        return <td key={i}>{insideData?.expense_count}</td>;
                      } else if (header?.value === "sales") {
                        return <td key={i}>{insideData?.sales_count}</td>;
                      } else if (header?.value === "total") {
                        return <td key={i}>{insideData?.total_count}</td>;
                      }
                    }
                  )}
                </tr>
              );
            })
        )}
    </>
  );
};

export default SignleUserWiseTableData;
